import { render, staticRenderFns } from "./ClearFormatting.vue?vue&type=template&id=844ba9de"
import script from "./ClearFormatting.vue?vue&type=script&lang=js"
export * from "./ClearFormatting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports